import { Box, Card, Center, Flex, Image, Link, Text } from "@chakra-ui/react";
import { type SignClientTypes } from "@walletconnect/types";

import { CodeSandboxIcon } from "@/assets/icons";
import { useColor } from "@/styles/useColor";

type Props = {
  metadata: SignClientTypes.Metadata;
  intention?: string;
};

/**
 * dApp project info card. Contains verification info to help user decide if the dApp is safe to connect.
 */
export const ProjectInfoCard = ({ metadata, intention }: Props) => {
  const { icons, name, url } = metadata;
  const color = useColor();

  return (
    <Box textAlign="center">
      <Flex justifyContent="center" width="100%">
        <Box
          width="60px"
          height="60px"
          marginRight="12px"
          textAlign="center"
          borderRadius="50%"
          backgroundColor={color("100")}
        >
          <Center flex="0 0 auto" width="60px" height="100%">
            <Image
              borderRadius="50%"
              objectFit="cover"
              alt={name || "dApp icon"}
              fallback={
                <span aria-label={name || "dApp icon"} role="img">
                  <CodeSandboxIcon width="36px" height="36px" />
                </span>
              }
              src={icons[0]}
            />
          </Center>
        </Box>
      </Flex>
      {/* <Box>
        <Avatar marginX="auto" size="lg" src={icons[0]} />
      </Box> */}
      <Box marginTop="16px">
        <Card data-testid="session-info-card-text">
          <Text as="span" fontWeight="bold">
            {name}
          </Text>
          <Text size="md">wants to {intention ?? "connect"}</Text>
        </Card>
      </Box>
      <Box marginTop="16px">
        <Link
          verticalAlign="middle"
          marginLeft="8px"
          data-testid="session-info-card-url"
          href={url}
          isExternal
        >
          {url}
        </Link>
      </Box>
    </Box>
  );
};
